import { RG_TYPE as u, RgCreate as g, DefaultBuilding as l, RgChildren as d } from "@project-rouge/rg-core";
import { getMatrix as f } from "../geometry-utils/three/index9.js";
import { matrixToRgTransform as s } from "../geometry-utils/three/index16.js";
function B({ parent: i }) {
  if (i.type === u.Building)
    return i;
  const r = g(l, []);
  return n({ obj: i, mergedChildren: r.children }), r;
}
function n({ obj: i, mergedChildren: r = [], parentMx: e }) {
  const t = f(i);
  if (e && t.premultiply(e), d.Building.includes(i.type)) {
    i = Object.assign({}, i), { pos: i.pos, rot: i.rot } = s(t), r.push(i);
    return;
  }
  for (const o of i.children)
    n({ obj: o, mergedChildren: r, parentMx: t });
}
export {
  B as MergeBuildings
};
//# sourceMappingURL=index22.js.map
